import { Link } from 'react-router-dom';
import { Icon } from '@sakhtar/design-system/react';
import { useAiPreview } from '../../aiPreview.js';

export interface WorkspaceBlockedProps {
  readonly reason: 'suspended' | 'not-permitted';
}

/**
 * Frames K (tenant suspended) and L (user not permitted): they replace the
 * whole conversation workspace, they are not messages.
 *
 * Honesty: in the product the BACKEND decides these states; here
 * `useAiPreview().forcedState` stands in for it, so the panel offers a
 * preview-only way back. The support button of frame K has no endpoint behind
 * it (no contact channel exists in this repo) and is therefore shown disabled.
 */
export function WorkspaceBlocked({ reason }: WorkspaceBlockedProps) {
  const ai = useAiPreview();
  const suspended = reason === 'suspended';
  return (
    <div className="sk-card sk-card--clipped ai-blocked" data-reason={reason}>
      <div className="ai-blocked__panel" role="alert">
        <span className="ai-blocked__mark" aria-hidden="true">
          <Icon name="shield" size="lg" />
        </span>
        <h2 className="ai-blocked__title">
          {suspended ? 'دسترسی سازمان معلق است' : 'به دستیار هوشمند دسترسی ندارید'}
        </h2>
        <p className="ai-blocked__text">
          {suspended
            ? 'حساب سازمان شما موقتاً معلق شده است. دستیار در این مدت پرسش نمی‌پذیرد و سابقهٔ گفتگوها دست‌نخورده می‌ماند.'
            : 'استفاده از دستیار برای نقش شما فعال نیست. مدیر سازمان می‌تواند آن را در تنظیمات دستیار روشن کند.'}
        </p>
        {suspended ? (
          <button
            type="button"
            className="sk-btn sk-btn--secondary sk-btn--sm"
            disabled
            title="کانال تماس با پشتیبانی در نسخهٔ نمایشی فعال نیست"
          >
            تماس با پشتیبانی ساختار
          </button>
        ) : ai.isTenantAdmin ? (
          <Link to={`${ai.base}/ai/settings`} className="sk-btn sk-btn--secondary sk-btn--sm">
            تنظیمات دستیار
          </Link>
        ) : null}
        <div className="ai-blocked__preview">
          <span className="sk-tag ai-sample-tag">نمونه</span>
          <span>این حالت از انتخابگر «نمایش حالت» آمده است.</span>
          <button
            type="button"
            className="sk-btn sk-btn--ghost sk-btn--sm"
            onClick={() => ai.setForcedState('none')}
          >
            بازگشت به حالت عادی
          </button>
        </div>
      </div>
    </div>
  );
}
